import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './login.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';


const apiUrl = process.env.REACT_APP_BASEURL;

export default function Login(props) {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState(false);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [error, setError] = useState();

  useEffect(() => {
    if (alert) {
      setTimeout(() => { setAlert(false); }, 5000);
    }
  },
    [alert]);




  async function loginUser(credentials) {
    // console.log("here are your credenials login 25",credentials);
    axios.post(apiUrl + "/api/Users/AuthenticateUser", credentials, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        // console.log("here is your token at login.js loginUser: ", response.data);
        props.setToken(response.data);
        navigate('/');
        // console.log("Token after setting: ", props.token); // Log the token after setting it
        // console.log(response.data);
      }
      )
      .catch((error) => {
        console.log(error);
        setError(error);
      });
  }



  const getUserData = async () => {

    const response = await axios.get(apiUrl + `/api/Users/GetUser?emailAddress=${username}`, {
      headers: headers
    })
      .then((response) => {
        setUserData(response.data)
      })
      .catch((error) => {
        console.log(error);

      });
  };


  useEffect(() => {
    getUserData();
  }, [username]);




  const handleSubmit = async e => {
    e.preventDefault();
    getUserData();
    const thisToken = await loginUser({
      username,
      password
    });

  }

  const headers = ({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': 'Bearer ' + props.token
  });


  return (
    <div className="flex items-center justify-center min-h-screen bg-white fadeInDown">
      <div className="bg-white p-8 rounded-lg shadow-[1px_2px_13px_2px_rgba(0,0,0,0.2)] w-96 transform transition-all duration-500 ease-in-out">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6 fadeIn first">Log In</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              id="loginName"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-500 ease-in-out bg-gray-100 hover:bg-white focus:border-blue-500 fadeIn second"
              placeholder="Email"
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              id="loginPwd"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-500 ease-in-out bg-gray-100 hover:bg-white focus:border-blue-500 fadeIn third"
              placeholder="Password"
            />
            {userData.accountSuspended && (
              <Alert severity="error" className="mt-2 animate-shake fadeIn fourth">
                Your account has been suspended due to 3 incorrect attempts!
              </Alert>
            )}
            {error && !userData.accountSuspended && (
              <Alert severity="error" className="mt-2 animate-shake fadeIn fourth">
                Incorrect email or password!
              </Alert>
            )}
          </div>
          <div className="mt-6">
            <button
              type="submit"
              className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-all duration-300 ease-in-out transform hover:scale-105 fadeIn fourth"
            >
              Log In
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};